<template>
    <div :class="[userTableView ? '' : 'container']">
        <template v-if="shopList && shopList.length === 0">
            <p>{{$t('REGISTRATION.noShops')}}</p>
        </template>
            <div name="slide-up" tag="div" class="row py-0 offset-1" v-else>
                <!--
                <vue-table :shops="shopList" :perPage="perPage" :tableFields="registrationTableFields" >
                    <template slot="buttons" slot-scope="props">
                        <registration-table-buttons
                            :shop="props.data"
                            :index="`shop-table-row-${props.index}`"
                            :key="`${userTableView ? user.id : 'shop-id'}_${props.data.id}`"
                            :userTableView="userTableView"
                            :hideAddition="hideAddition"
                            @editShop="editShop($event)"
                            @addUserToShop="$emit('addUserToShop', $event)"
                            @removeShopFromUser="$emit('removeShopFromUser', $event)"
                            @open="showModal"
                            >
                        </registration-table-buttons>
                    </template>
                </vue-table>
                -->
                <shop-table-row :hideAddition="hideAddition"
                                :userTableView="userTableView"
                                :key="`${userTableView ? user.id : 'shop-id'}_${shop.id}`"
                                :index="`shop-table-row-${index}`"
                                :shop="shop"
                                @editShop="editShop(shop)"
                                @removeShopFromUser="$emit('removeShopFromUser', $event)"
                                @addUserToShop="$emit('addUserToShop', $event)"
                                v-for="(shop, index) in shopList"/>
            </div>
    </div>
</template>

<script type="text/babel">
import Filters from '../../../../mixins/CphFilters.vue';
import {mapActions, mapGetters} from 'vuex';
import {RegistrationPerimeter} from '../../../../router/perimeters/registrationPerimeter';
import ShopTableRow from './ShopTableRow';
import ClipLoader from 'vue-spinner/src/ClipLoader.vue';
import Table from '../../Table/Table';
import RegistrationShopsTableButtons from '../RegistrationShopsTableButtons';
import RegistrationTableFields from '../../../../utilities/tablesProperties/RegistrationTableFields';
import _ from 'underscore';
export default {
    name: 'ShopsTable',
    components: {ShopTableRow, ClipLoader, 'vue-table': Table, 'registration-table-buttons': RegistrationShopsTableButtons},
    perimeters: [RegistrationPerimeter],
    data () {
        return {
            err: false,
            loading: true,
            perPage: 10,
            registrationTableFields: RegistrationTableFields,
            showUserModal: false
        };
    },
    props: {
        userShops: {
            type: Array
        },
        hideAddition: {
            type: Boolean,
            default: false
        },
        userTableView: {
            type: Boolean,
            default: false
        },
        user: {
            required: false
        }
    },
    mixins: [Filters],
    computed: {
        ...mapGetters({
            shops : 'getUserShops',
            userId: 'getUserId',
            userData: 'getUser',
            allShops: 'getShops'
        })
    },
    asyncComputed: {
        shopList () {
            if (this.userShops) {
                return this.userShops;
            }
            return new Promise((resolve) => {
                if (this.userData && this.userData.role === this.$TYPES.ROLES.ADMIN) {
                    return this.$store.dispatch('GetAllShops').then(res => resolve(res.data));
                }
                this.$utils.resolvePromises(
                    this.shops.map(shopId => this.$store.dispatch('GetShopById', shopId))
                ).then(res => resolve(res));
            });
        }
    },
    methods: {
        ...mapActions([
            'confirmAction',
            'DelShop'
        ]),
        editShop (shop) {
            this.$emit('changeTab', {name: 'ShopRegister', data: shop});
        },
        addShop ({name}) {
            this.$emit('changeTab', {name: name, data: null});
        },
        showModal () {
        }
    },
    mounted (){        
        this.$store.dispatch('GetAllShops', {id: this.userId});
        this.$store.dispatch('GetUserShopsIds');
        let a = _.map(this.allShops, (s) => {
            return s.id;
        });
        //const idstodelete = _.difference(a,this.shops);
        //console.log(idstodelete);
        /*_.each(idstodelete, (v) => {
        console.log(v);
        this.$store.dispatch('DelShopFromUser', { id: this.userId , shopId: v})
      });*/
        /*_.each(a, (v) => {
        console.log(v);
        this.$store.dispatch('AddShopToUser', { user: { id: this.userId } , shop: { id: v }})
      });*/
    }
};

</script>
